(() => {
  // Stable marker that survives Shopify minification so we can verify the file is loaded.
  window.__TBW_KACHING_HOTFIX_V1__ = "1";

  const hide = () => {
    const bars = document.querySelector(".kaching-bundles__bars");
    if (!bars) return false;

    // Avoid :scope for maximum compatibility.
    const firstBar = Array.from(bars.children).find(
      (el) => el?.classList && el.classList.contains("kaching-bundles__bar")
    );
    if (!firstBar) return false;

    const products = firstBar.querySelector(
      ".kaching-bundles__bar-collection-products"
    );
    if (!products) return false;

    products.style.setProperty("display", "none", "important");
    products.style.setProperty("margin-top", "0", "important");
    products.style.setProperty("padding-top", "0", "important");
    products.style.setProperty("padding-left", "0", "important");
    return true;
  };

  // Run now and keep applying while the app hydrates/rerenders.
  hide();
  const obs = new MutationObserver(() => hide());
  obs.observe(document.documentElement, { childList: true, subtree: true });

  // Disconnect eventually; if Kaching rerenders later, CSS still handles it.
  window.setTimeout(() => obs.disconnect(), 60000);
})();

(() => {
  // Keep product-card images on responsive Shopify CDN widths even after swatch scripts rewrite them.
  window.__TBW_CARD_IMAGE_RESPONSIVE_FIX_V1__ = "1";

  const CARD_IMAGE_SELECTOR = ".card__media img.motion-reduce";
  const RESPONSIVE_WIDTHS = [165, 360, 533, 720, 940, 1066];
  const DEFAULT_WIDTH = 533;

  const isElement = (node) => node && node.nodeType === 1;

  const normalizeUrl = (url) =>
    String(url || "")
      .trim()
      .replace(/^\/\//, "https://")
      .replace(/&amp;/g, "&");

  const stripWidthParam = (url) => {
    if (!url) return "";
    const stripped = url
      .replace(/([?&])width=\d+(&|$)/g, "$1")
      .replace(/[?&]$/, "");
    return stripped;
  };

  const addWidthParam = (url, width) => {
    const base = stripWidthParam(url);
    if (!base) return "";
    return `${base}${base.includes("?") ? "&" : "?"}width=${width}`;
  };

  const extractFirstSrcsetUrl = (srcset) => {
    if (!srcset) return "";
    const first = srcset.split(",")[0] || "";
    return normalizeUrl(first.trim().split(/\s+/)[0]);
  };

  const hasResponsiveWidthSet = (srcset) =>
    /[?&]width=\d+\s+\d+w/.test(String(srcset || ""));

  const buildResponsiveSrcset = (baseUrl) =>
    RESPONSIVE_WIDTHS.map((w) => `${addWidthParam(baseUrl, w)} ${w}w`).join(",");

  const looksLikeShopifyProductFile = (url) =>
    /\/cdn\/shop\/files\//.test(url) || /cdn\.shopify\.com\/s\/files\//.test(url);

  const optimizeCardImage = (img) => {
    if (!isElement(img)) return;

    const srcAttr = normalizeUrl(img.getAttribute("src"));
    const srcsetAttr = String(img.getAttribute("srcset") || "");
    const dataSrcsetAttr = String(img.getAttribute("data-srcset") || "");

    const candidateBase = stripWidthParam(
      srcAttr || extractFirstSrcsetUrl(srcsetAttr) || extractFirstSrcsetUrl(dataSrcsetAttr)
    );
    if (!candidateBase || !looksLikeShopifyProductFile(candidateBase)) return;

    const srcIsUnsized = srcAttr && !/[?&]width=\d+/.test(srcAttr);
    const srcsetNeedsFix = !srcsetAttr || !hasResponsiveWidthSet(srcsetAttr);
    const dataSrcsetNeedsFix = !!dataSrcsetAttr && !hasResponsiveWidthSet(dataSrcsetAttr);

    if (!srcIsUnsized && !srcsetNeedsFix && !dataSrcsetNeedsFix) return;

    const responsiveSrcset = buildResponsiveSrcset(candidateBase);
    img.setAttribute("src", addWidthParam(candidateBase, DEFAULT_WIDTH));
    img.setAttribute("srcset", responsiveSrcset);
    if (dataSrcsetAttr || dataSrcsetNeedsFix) {
      img.setAttribute("data-srcset", responsiveSrcset);
    }
  };

  const optimizeWithin = (root) => {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(CARD_IMAGE_SELECTOR).forEach(optimizeCardImage);
  };

  const start = () => {
    optimizeWithin(document);

    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === "attributes") {
          const target = mutation.target;
          if (isElement(target) && target.matches(CARD_IMAGE_SELECTOR)) {
            optimizeCardImage(target);
          }
          continue;
        }

        for (const node of mutation.addedNodes) {
          if (!isElement(node)) continue;
          if (node.matches(CARD_IMAGE_SELECTOR)) {
            optimizeCardImage(node);
          }
          optimizeWithin(node);
        }
      }
    });

    observer.observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ["src", "srcset", "data-srcset"],
    });

    window.setTimeout(() => observer.disconnect(), 60000);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
